export default __webpack_public_path__ + "static/media/eight.8a66a957.jpeg";